import React, { useContext } from 'react';
import BurgerMenu from '@/components/layouts/BurgerMenu';
import Overlay from '@/components/atoms/Overlay';
import { StateContext } from '@/state/store';

import './BurgerMenuOverlay.scss';

const BurgerMenuOverlay = () => {
    const store = useContext(StateContext);
    const { dispatch } = store;
    const { burgerMenuVisible } = store.state;

    const closeBurgerMenu = () => {
        dispatch({ type: 'HIDE_BURGER_MENU' });
    };

    return (
        <div className="BurgerMenuOverlay">
            <Overlay open={burgerMenuVisible} onAnimationEndCallback={closeBurgerMenu}>
                <BurgerMenu ctaCallback={closeBurgerMenu} />
            </Overlay>
        </div>
    );
};

export default BurgerMenuOverlay;
